import {SELECTIVE_GATE_LABELS} from '../shared/signal-policy.js';

export default function AssetEvaluationList({rows}){
  if(!Array.isArray(rows)||!rows.length)return null;
  return <details style={{marginTop:12}}><summary>Avaliação individual dos {rows.length} ativos</summary>
    <div style={{overflowX:'auto'}}><table style={{width:'100%',textAlign:'left'}}>
      <thead><tr><th>Ativo</th><th>EMA35 / direção</th><th>Demais filtros</th><th>Resultado</th></tr></thead>
      <tbody>{rows.map(row=><tr key={row.active_id}>
        <td>{row.ativo}</td>
        <td>{row.clock??'—'} · {row.direcao==='CALL'?'Compra':row.direcao==='PUT'?'Venda':'Fora das faixas'}</td>
        <td>{row.indicators_evaluated?'Verificados':'Não calculados: EMA35 reprovada'}</td>
        <td>{row.approved?'Aprovado':`Reprovado: ${(row.rejected_by??[]).map(key=>SELECTIVE_GATE_LABELS[key]??key).join('; ')}`}</td>
      </tr>)}</tbody>
    </table></div>
  </details>;
}
